// apps/merchant-v3/src/lib/theme/themeStore.ts
//
// Phase 6 Wave 2 Task 06 — Zustand theme store. Persists the user's
// preference (`light` | `dark` | `system`) to localStorage at
// `merchant-v3.theme.v1`. The actual `<html class="dark">` toggle is
// handled by ThemeProvider — this store is the single source of truth
// for the preference value and exposes a `setTheme` mutator the
// TopBar / Settings UI can call.
//
// vg-binding: PLAN:task-06
// vg-binding: P6.D-221

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type ThemePreference = 'light' | 'dark' | 'system';

export interface ThemeStore {
  theme: ThemePreference;
  setTheme: (theme: ThemePreference) => void;
}

const STORAGE_KEY = 'merchant-v3.theme.v1';

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      theme: 'system',
      setTheme: (theme) => set({ theme }),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
      version: 1,
    },
  ),
);

/** Convenience selector. */
export function useThemePreference(): ThemePreference {
  return useThemeStore((s) => s.theme);
}
